<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
      return {
        requestBody:{"appId":"b43b64a70f5ea976aa842bec0734bf29"},
        responseCode:{"data":{"accessToken":"b43b64a70f5ea976aa842bec0734bf29"},"message":"业务成功","resultCode":0,"status":1},
        infoData: {
          explain: "第三方系统主动请求开放平台，获取微信公众号access_token",
          t_url: this.commonUrls.test+"getWeixinAccessToken",
          p_url: this.commonUrls.prod+"getWeixinAccessToken",
          precondition: "该接口需要第三方保存有用户的token等信息",
          pattern: "智慧停车开放平台提供接口，第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'appId', info2: '是', info3: 'String', info4: '微信appId' },
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
            td: [
              { info1: 'accessToken', info2: '是', info3: 'String', info4: '公众号access_token' },
            ]
          }
          ]
        }
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getWeixinAccessToken.vue